import { FLOATING_ELEMENT_PLACEMENT } from '../../../../constants/common'

export const DOC_FLOW_SELECT_AREA_INFO_OFFSET = 4

export const DOC_FLOW_SELECT_AREA_INFO_FALLBACK_PLACEMENTS = [
  FLOATING_ELEMENT_PLACEMENT.top,
]

export const DOC_FLOW_SELECT_AREA_INFO_MAX_HEIGHT_CSS_VARIABLE =
  '--doc-flow-select-area-info-max-height'
